import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import ENV from '@/constants/env'

declare global {
    interface Window {
        Pusher: typeof Pusher
    }
}

window.Pusher = Pusher

// Messaging runs on its own Pusher app (separate key/app id from Breeze's `window.echo`),
// so it needs its own Echo client. Channels here are all public (`public-org-messaging-*`),
// so no authEndpoint/auth headers are configured.
const getMessagingEcho = (): Echo => {
    if (window.messagingEcho === undefined) {
        const { appKey, cluster } = JSON.parse(ENV.messagingPusher || `{}`)

        window.messagingEcho = new Echo({
            broadcaster: 'pusher',
            key: appKey,
            cluster,
            forceTLS: true,
            encrypted: true
        })
    }

    return window.messagingEcho
}

export default getMessagingEcho
